import React from 'react';

import { Columns, Column } from '../../styled/Columns/wrappers';
import { StoreIcon } from '../../styled/Icon';
import Text from '../../styled/Text';

import Distance from '../../styled/Distance';
import { Action } from '../../styled/StockStatus/wrappers';

interface INoStore {
  onClick: () => void;
}

const NoStore = ({ onClick }: INoStore) => {
  return (
    <Columns className="space-2">
      <Column>
        <StoreIcon className="large bump-down" />
      </Column>
      <Column style={{ width: '100%' }}>
        <Text size="large">Lagerstatus i butik</Text>
        <Distance size="1" />
        <Action onClick={onClick}>Välj din butik</Action>
      </Column>
    </Columns>
  );
};

export default NoStore;
